import React from "react"
import { Gyroscope } from "components"

const GyroscopeBlock = props => (
  <Gyroscope {...props} />
)

export default GyroscopeBlock



// WEBPACK FOOTER //
// ./src/blocks/gyroscope/index.jsx